import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../Shared/API/config';

export interface RecentActivity {
  id: string | number;
  message: string;
  date: string;
  type: string;
}

export interface ScheduleItem {
  id: number;
  className: string;
  subject: string;
  topic?: string;
  time: string;
  room: string;
  status?: string;
  lessonId?: number | null;
  workSchemeId?: number | null;
}

export interface lessonNote {
  id: number;
  date: string;
  subjectName: string;
  topicName: string;
  className: string;
  lessonCount: number;
  sessionName: string;
}

export interface MissedAttendanceDate {
    date: string;
    classId: number;
    className: string;
    markedStudents: number;
    totalStudents: number;
}

export interface CollectorRecentPayment {
  studentId: number;
  student: string;
  paymentDate?: string | null;
  amount: number;
  isDigital?: boolean;
}

export interface StaffDashboardData {
  myClasses: number;
  myStudents: number;
  unmarkedClasses: number;
  pendingMarksEntry: number;
  todayAbsent?: number;
  todayPresent?: number;
  recentActivity: RecentActivity[];
  schedule: ScheduleItem[];
  lessonNotes: lessonNote[];
  missedAttendanceDates: MissedAttendanceDate[];
  // Fee-collector-only fields (empty/zero for other staff roles)
  collectedToday?: number;
  collectedThisWeek?: number;
  recentPayments?: CollectorRecentPayment[];
}

export enum NotificationType {
  MARKS_ENTRY = 'marks_entry',
  ATTENDANCE = 'attendance',
  WELCOME = 'welcome',
}

export interface BaseNotification {
  id: string;
  type: NotificationType;
  timestamp: Date;
}

export interface MarksEntryNotification extends BaseNotification {
  type: NotificationType.MARKS_ENTRY;
  subject: string;
  className: string;
  completionRate?: number;
}

export interface AttendanceNotification extends BaseNotification {
  type: NotificationType.ATTENDANCE;
  date: Date;
  isMarked: boolean;
}

export interface WelcomeNotification extends BaseNotification {
  type: NotificationType.WELCOME;
  message: string;
}

export type Notification =
  | MarksEntryNotification
  | AttendanceNotification
  | WelcomeNotification;

export interface NotificationsCardProps {
  recentActivity?: RecentActivity[];
}

export const StaffDashboardApi = createApi({
  reducerPath: 'StaffDashboardApi',
  baseQuery,
  tagTypes: ['StaffDashboard'],
  endpoints: builder => ({
    getStaffDashboardData: builder.query<StaffDashboardData, void>({
      query: () => `/dashboard/staff-data`,
      providesTags: ['StaffDashboard'],
      keepUnusedDataFor: 300, // 5 minutes cache
    }),
  }),
});

export const { useGetStaffDashboardDataQuery } = StaffDashboardApi;
